import { useListBenchmarkCollectionsQuery } from '@vizit/api';

/** How many of a benchmark's collections are read by name: enough for the delete and remove confirms to list them. */
const BENCHMARK_COLLECTIONS_PAGE_SIZE = 20;

interface UseBenchmarkCollectionsProps {
  workspaceId?: string;
  benchmarkId?: string | null;
}

/**
 * The collections scored against a benchmark, by name, for the delete and remove-images confirms to list. How many
 * there are comes from the benchmark itself (`collectionCount`), so this reads only the first page of names, once the
 * workspace and benchmark are known. `collections` stays `undefined` while they are unknown (still loading, or the lookup failed).
 */
function useBenchmarkCollections({ workspaceId, benchmarkId }: UseBenchmarkCollectionsProps) {
  const { data } = useListBenchmarkCollectionsQuery(
    { workspace_id: workspaceId ?? '', benchmark_id: benchmarkId ?? '', limit: BENCHMARK_COLLECTIONS_PAGE_SIZE },
    { enabled: !!workspaceId && !!benchmarkId },
  );

  return {
    /** The first page of collections, by name; `undefined` until known */
    collections: data?.collections,
  };
}

export { useBenchmarkCollections };
